import {gql} from '@apollo/client'

export const GET_ALL_COMMISSION_REPORTS_API = gql`
  query allCommissionReports(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $status: String
    $name: String
    $effectiveMonth: Int
    $effectiveYear: Int
    $carrier: String
    $stateEU: String
    $createdBy: ID
    $hasActiveClaims: Boolean
  ) {
    allCommissionReports(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: $status
      name: $name
      effectiveMonth: $effectiveMonth
      effectiveYear: $effectiveYear
      carrier: $carrier
      stateEU: $stateEU
      createdBy: $createdBy
      hasActiveClaims: $hasActiveClaims
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          effectiveMonth
          effectiveYear
          totalApproved
          totalPending
          totalNotAssigned
          totalActiveClaims
          paidDate
          status
          created
          approvePreviousYear
          createdBy {
            id
            firstName
            lastName
            email
            organization {
              id
              name
            }
          }
          carrier {
            id
            name
          }
          stateEU {
            id
            name
          }
        }
      }
    }
  }
`

export const GET_COMMISSION_REPORT_BY_ID_API = gql`
  query commissionReportById($id: String) {
    commissionReportById(id: $id) {
      id
      name
      effectiveMonth
      effectiveYear
      totalApproved
      totalPending
      totalNotAssigned
      paidDate
      status
      approvePreviousYear
      createdBy {
        id
        firstName
        lastName
        email
      }
      carrier {
        id
        name
      }
      stateEU {
        id
        name
        code
      }
    }
  }
`

export const GET_COMMISSION_REPORT_LOGS = gql`
  query commissionReportLogsByReportId($reportId: Int!) {
    commissionReportLogsByReportId(reportId: $reportId) {
      id
      oldValue
      newValue
      updatedAt
      user {
        id
        firstName
        lastName
      }
      changes
    }
  }
`

export const GET_COMMISSION_REPORT_ASYNC_TASK = gql`
  query commissionReportAsyncTask($taskId: String!) {
    commissionReportAsyncTask(taskId: $taskId) {
      taskId
      status
      progressPercentage
      progressMessage
      result
      errorMessage
    }
  }
`

export const GET_PAYROLL_TOTALS = gql`
  query commissionReportPayrollTotals(
    $dateFrom: Date!
    $dateTo: Date!
    $userId: ID
    $carrierId: ID
  ) {
    commissionReportPayrollTotals(
      dateFrom: $dateFrom
      dateTo: $dateTo
      userId: $userId
      carrierId: $carrierId
    ) {
      userId
      userFirstName
      userLastName
      userEmail
      reports {
        reportId
        reportName
        totalCommission
        totalChargeback
        totalDeduction
        totalBonus
        total
      }
      grandTotal
    }
  }
`
